import { ReactElement } from 'react';

import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

interface Props {
  columnNumber?: number;
  rowNumber?: number;
}

export const DatatableSkeleton = ({
  columnNumber = 7,
  rowNumber = 10,
}: Props): ReactElement => {
  return (
    <TableContainer
      component={Paper}
      style={{ minHeight: '380px', height: '100%' }}
    >
      <Table>
        <TableHead>
          <TableRow>
            {Array.from({ length: columnNumber }, (_, i) => i + 1).map((i) => (
              <TableCell key={i} align="right">
                <Skeleton variant="rectangular" />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rowNumber }, (_, i) => i + 1).map((i) => (
            <TableRow key={i}>
              {Array.from({ length: columnNumber }, (_, j) => j + 1).map(
                (j) => (
                  <TableCell key={j} align="right">
                    <Skeleton variant="text" />
                  </TableCell>
                ),
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
